import { productListPreviouslyPurchasedFilterStyles } from "@insite/content-library/Widgets/ProductList/ProductListPreviouslyPurchasedFilter";
import { StyleProps as CheckboxStyleProps } from "@insite/mobius/Checkbox/Checkbox";
import getProp from "@insite/mobius/utilities/getProp";
import { COLORS, TYPOGRAPHY } from "@tCentro/theme/design";
import { css } from "styled-components";

productListPreviouslyPurchasedFilterStyles.checkBox = {
    css: css<CheckboxStyleProps>`
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: row-reverse;
        span {
            border: 2px solid #9e9d9e !important;
            font-size: ${TYPOGRAPHY.size.smaller} !important;
            &:focus {
                box-shadow: none !important;
            }
        }
        label {
            font-weight: ${TYPOGRAPHY.weight.base};
            font-size: ${TYPOGRAPHY.size.smaller};
            line-height: 20px;
            color: ${getProp("theme.typography.p.color")};
            width: 100%;
            margin: 0 !important;
            > div {
                div {
                    &:first-child {
                        word-break: break-word;
                        flex-basis: 94% !important;
                    }
                    &:last-child {
                        display: flex;
                        justify-content: flex-end;
                        flex-basis: 30% !important;
                    }
                }
            }
        }
        span[role="checkbox"] {
            height: 24px;
            width: 24px;
            border-radius: 2px !important;
            min-width: 24px !important;
            svg {
                height: 24px;
                width: 24px;
            }
        }
    `,
};

productListPreviouslyPurchasedFilterStyles.checkBoxSelected = {
    css: css<CheckboxStyleProps>`
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: row-reverse;
        span {
            border: 2px solid ${COLORS.black} !important;
            font-size: ${TYPOGRAPHY.size.smaller} !important;
            &:focus {
                box-shadow: none !important;
            }
        }
        label {
            font-weight: ${TYPOGRAPHY.weight.base};
            font-size: ${TYPOGRAPHY.size.smaller};
            line-height: 20px;
            color: ${getProp("theme.typography.p.color")};
            width: 100%;
            margin: 0 !important;
            > div {
                div {
                    &:first-child {
                        word-break: break-word;
                        flex-basis: 94% !important;
                    }
                    &:last-child {
                        display: flex;
                        justify-content: flex-end;
                        flex-basis: 30% !important;
                    }
                }
            }
        }
        span[role="checkbox"] {
            height: 24px;
            width: 24px;
            min-width: auto !important;
            border-radius: 2px !important;
            background: none !important;
            color: ${COLORS.black} !important;
            svg {
                height: 24px;
                width: 24px;
            }
        }
    `,
    typographyProps: {
        css: css`
            word-break: break-all;
        `,
        weight: "bold",
    },
};
